const Footer = ({ switchColor }) => {
  return (
    <footer className="container text-center mb-4">
      Game created by{" "}
      <a href="http://www.aahunt.co.uk/" target="_blank" rel="noreferrer">
        Ashley Hunt.
      </a>{" "}
      <p>Using the MERN stack (MongoDB, Express, React, Node.js)</p>
      <p>
        All rights reserved 2021 &copy; Open Source API from:{" "}
        <a href="https://opentdb.com/" target="_blank" rel="noreferrer">
          https://opentdb.com/
        </a>
      </p>
      <p className="font-weight-bold">Dark mode</p>
      <div className="text-center">
        <input type="checkbox" id="switch" onChange={switchColor} />
        <label htmlFor="switch">Toggle Dark Mode</label>
      </div>
    </footer>
  )
}

export default Footer
